import React, { useState, useRef } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { ContextMenu } from 'primereact/contextmenu'
import CancelIcon from '@mui/icons-material/Cancel'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { Tooltip } from '@mui/material'
import { useTranslation } from "react-i18next"
import './utils.css'
import { Settings } from '@mui/icons-material'

export default function TableBookingEquipments({ 
    value, 
    setValue, 
    fillFields,
    containerIndex, 
    setContainerIndex, 
    isView, 
    isApprove, 
    setOpenDrawer, 
    selectedLine, 
    setSelectedLine, 
    reprovedRows, 
    EquipmentIndex, 
    setEquipmentIndex, 
    setDrawerName, 
    isForSplit, 
    onPassLine, 
    color, 
    secondColor 
}) {

    const { t } = useTranslation()
    const cm = useRef(null)
    const [line, setLine] = useState(null)
    const [selectedRows, setSelectedRows] = useState(reprovedRows)

    const columns = [
        { label: 'Equipment', type: 'textfield', code: 'EquipmentNumber' },
        { label: 'Equipment Type', type: 'textfield', code: 'EquipmentType' },
        { label: 'Park Code', type: 'textfield', code: 'ParkCode' },
        { label: 'Terminal Loading Code', type: 'textfield', code: 'TerminalLoadLocation' },
        { label: 'Terminal Discharge Code', type: 'textfield', code: 'TerminalDischargeLocation' },
        { label: 'Booking Date', type: 'date', code: 'BookingDate' },
        { label: 'Gate Date', type: 'date', code: 'GateDate' },
    ]
    const menuModel = [
        { label: 'Equipment Options', command: () => openDrawerFunc(selectedLine) },
        { separator: true },
        { label: 'Copy Line', command: () => copyLine(selectedLine) },
        { label: 'Delete Line', command: () => deleteRow(selectedLine) },
    ]
    const modalApprove = [
        { label: 'Equipment Options', command: () => openDrawerFunc(selectedLine) }
    ]

    const openDrawerFunc = () => {
        setOpenDrawer(true)
    }

    const dynamicColumns = columns.map((value, key) => {
        if (value.type === 'date') {
            return <Column 
                headerStyle={{ borderBottom: `2px solid var(--color-blue)`, color: 'var(--color-black)' }} 
                style={{ cursor: 'default' }} 
                key={key} 
                field={value.code} 
                header={value.label} 
                body={(data) => textDisplayDate(data, value.code)} 
            />
        }
        return <Column 
            headerStyle={{ borderBottom: `2px solid var(--color-blue)`, color: 'var(--color-black)' }} 
            style={{ cursor: 'default' }} 
            key={key} 
            field={value.code} 
            header={value.label} 
            body={(data) => textDisplay(data, value.code)} 
        />
    })

    const textDisplay = (rowData, code) => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '42px', padding: '0 10px' }}>
                <span>{rowData[code] || ''}</span>
            </div>
        )
    }

    const textDisplayDate = (rowData, code) => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '42px', padding: '0 10px' }}>
                <span>{rowData[code] || ''}</span>
            </div>
        )
    }

    const copyLine = (data) => {
        let tempEquipmentIndex = EquipmentIndex
        tempEquipmentIndex++
        const tempObj = {
            ...data,
            id: containerIndex,
            EquipmentIndex: tempEquipmentIndex,
        }
        setContainerIndex(containerIndex + 1)
        setValue(prev => [...prev, tempObj])
        setEquipmentIndex(tempEquipmentIndex)
    }

    const deleteRow = (data) => {
        const newValue = value.filter(obj => obj.id !== data.id)
        setValue(newValue)
    }

    const selectUnselect = (value) => {
        let temp
        if (line) {
            if (line.id === value.id) {
                temp = null
            } else {
                temp = value
            }
        } else {
            temp = value
        }
        setLine(temp)
        if (fillFields) {
            fillFields(temp)
        }
    }

    const clickRow = (data, e) => {
        const tempEl = e.target
        if (tempEl.className !== 'pi pi-ellipsis-v' && tempEl.tagName !== 'I' && tempEl.tagName !== 'svg' && tempEl.tagName !== 'path') {
            selectUnselect(data)
        }
    }

    const buttonEquipment = (data) => {
        return (
            <div style={{ minHeight: '42px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {isForSplit || isApprove || isView ? (
                    <Tooltip title={t('equipmentOptions')}>
                        <Settings className='cursorPointer' style={{ color: 'var(--color-green)', transform: 'scale(.8)' }}
                            onClick={() => {
                                openDrawerFunc()
                                setSelectedLine(data)
                                setDrawerName('Equipment Options')
                            }} />
                    </Tooltip>
                ) : (
                    <>
                        <Tooltip title={t('deleteEquipment')}>
                            <CancelIcon className='buttonColorRed cursorPointer' style={{ transform: 'scale(.6)' }} onClick={() => deleteRow(data)} />
                        </Tooltip>
                        <Tooltip title={t('copyEquipment')}>
                            <ContentCopyIcon className='cursorPointer' style={{ transform: 'scale(.6)' }} onClick={() => copyLine(data)} />
                        </Tooltip>
                        <Tooltip title={t('equipmentOptions')}>
                            <Settings className='cursorPointer' style={{ color: 'var(--color-green)', transform: 'scale(.8)' }}
                                onClick={() => {
                                    openDrawerFunc()
                                    setSelectedLine(data)
                                    setDrawerName('Equipment Options')
                                }} />
                        </Tooltip>
                    </>
                )}
            </div>
        )
    }

    const onSelectionChangeSplit = (e) => {
        let tempValue = []
        if (e.type === 'all') {
            if (e.value.length) {
                selectedRows.forEach(obj => {
                    if (!e.value.find(rowObj => rowObj.id === obj.id)) {
                        tempValue.push(obj)
                    }
                })
                tempValue.push(...e.value)
            } else {
                selectedRows.forEach(obj => {
                    if (!value.find(rowObj => rowObj.id === obj.id)) {
                        tempValue.push(obj)
                    }
                })
            }
        } else {
            tempValue = [...e.value]
        }
        if (onPassLine) {
            onPassLine(tempValue)
        }
        setSelectedRows([...tempValue])
    }

    const subHeader = (data) => {
        return (
            <div style={{ paddingLeft: '5px', minWidth: '100px', minHeight: '42px' }}>
                <div className='image-text'>Shipment {data.Shipment}</div>
            </div>
        )
    }

    return (
        <>
            <div className='divPrincipalTable'>
                <div className='divTable' style={{ paddingBottom: '40px ' }}>
                    <ContextMenu model={isForSplit || isApprove || isView ? modalApprove : menuModel} ref={cm} onHide={() => { setLine(null) }} />
                    <DataTable
                        value={value}
                        groupRowsBy={["Shipment", "id"]}
                        rowGroupMode="rowspan"
                        className='tableEquipments'
                        size="small"
                        selectionMode={isForSplit ? "multiple" : ""}
                        selection={isForSplit && selectedRows}
                        onSelectionChange={onSelectionChangeSplit}
                        onContextMenuSelectionChange={e => {
                            setSelectedLine(e.value)
                            setLine(e.value)
                        }}
                        onContextMenu={e => cm.current.show(e.originalEvent)}
                        onRowClick={e => clickRow(e.data, e.originalEvent)}
                    >
                        {isForSplit && (
                            <Column
                                headerStyle={{
                                    borderBottom: `2px solid ${color || 'var(--color-blue)'}`,
                                    color: secondColor || 'var(--color-black)'
                                }}
                                selectionMode="multiple" 
                                className='TableSelectionColumn' 
                                frozen
                            />
                        )}
                        <Column 
                            className='shipmentNameBooking' 
                            headerStyle={{ borderBottom: `2px solid var(--color-blue)`, color: 'var(--color-black)', minWidth: '100px' }} 
                            field='Shipment' 
                            header='Shipment' 
                            body={subHeader} 
                        />
                        {dynamicColumns}
                        <Column 
                            field="id" 
                            headerStyle={{ borderBottom: `2px solid var(--color-blue)`, color: 'var(--color-black)' }} 
                            className='' 
                            body={buttonEquipment} 
                        />
                    </DataTable>
                </div>
            </div>
        </>
    )
}